import { FileText } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const Downloads = () => (
  <section className="section" data-testid="downloads-section">
    <div className="wrap">
      <Reveal>
        <div className="eyebrow">
          <span className="eyebrow-num">09</span>
          <span>Downloads</span>
        </div>
        {/* TODO: drop the real PDF at /app/frontend/public/downloads/install-instructions-en-es.pdf */}
        <div className="dl-card">
          <div className="card-ico">
            <FileText size={22} aria-hidden="true" />
          </div>
          <div>
            <a className="dl-link" href="/downloads/install-instructions-en-es.pdf" data-testid="download-instructions-link">
              Install Instructions (English / Español) — PDF
            </a>
            <p className="dl-note">
              Read the instructions before you buy. If the mount style or the rail fit is not obvious from them, call us.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
